import Choices from 'choices.js/public/assets/scripts/choices'

const registeredChoicesElements = [];

export {redrawChoices};

const fixSearchInput = (originalInput) => {
    const container = originalInput.closest('.choices')
    const searchInput = container.querySelector('.choices__input--cloned')

    searchInput.type = 'search'
    searchInput.setAttribute('autocomplete', 'choices-search')

    const updateWidth = () => {
        const value = searchInput.value
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const computedStyle = window.getComputedStyle(searchInput)
        context.font = computedStyle.font
        const textWidth = context.measureText(value).width
        const emSize = parseFloat(computedStyle.fontSize)
        const calculatedWidth = Math.max(2.75, (textWidth / emSize) + 2.75)
        const newWidthStr = `${calculatedWidth}em`

        if (searchInput.style.width !== newWidthStr) {
            observer.disconnect()
            searchInput.style.width = newWidthStr
            observer.observe(searchInput, {
                attributes: true,
                attributeFilter: ['style']
            })
        }
    }

    searchInput.addEventListener('input', updateWidth)
    searchInput.addEventListener('keydown', updateWidth)

    const observer = new MutationObserver(updateWidth)

    observer.observe(searchInput, {
        attributes: true,
        attributeFilter: ['style']
    })

    searchInput.style.width = '2.75em'
}

document.querySelectorAll('.choices').forEach(choicesContainer => {
    const originalInput = choicesContainer.querySelector('select, input')
    if (originalInput) {
        fixSearchInput(originalInput)
    }
})

const redrawChoices = () => {
	const allChoicesMultiselects = [...document.querySelectorAll('._choices-multiselect, [data-choices="multiselect"]')]
	const notSetUpChoicesMultiselects = allChoicesMultiselects.filter((choicesMultiselect) => !registeredChoicesElements.includes(choicesMultiselect))
	notSetUpChoicesMultiselects.map((item) => {
		registeredChoicesElements.push(item)
		
		item.choices = new Choices(item, {
			removeItemButton: true,
			duplicateItemsAllowed: false,
			delimiter: '\n',
			searchResultLimit: item.dataset.searchResultLimit,
			shouldSort: false,
			resetScrollPosition: false,
			loadingText: item.dataset.msgLoading,
			noResultsText: item.dataset.msgNoResults,
			noChoicesText: item.dataset.msgNoChoices,
			itemSelectText: item.dataset.msgItemSelect,
			addItemText: value => item.dataset.msgAddItem.replace('%value%', value),
			maxItemText: maxItemCount => {
				if (maxItemCount === 1) {
					return item.dataset.msgMaxItemOne
				} else if (maxItemCount >= 2 && maxItemCount <= 4) {
					return item.dataset.msgMaxItemTwoToFour.replace('%maxItemCount%', maxItemCount)
				} else {
					return item.dataset.msgMaxItemMore.replace('%maxItemCount%', maxItemCount)
				}
			}
		})
		
		fixSearchInput(item)
	})

	const allChoicesTextInputs = [...document.querySelectorAll('._choices-text-input, [data-choices="text-input"]')]
	const notSetUpChoicesTextInputs = allChoicesTextInputs.filter((choicesTextInput) => !registeredChoicesElements.includes(choicesTextInput))
	notSetUpChoicesTextInputs.map((item) => {
		registeredChoicesElements.push(item)
		
		item.choices = new Choices(item, {
			removeItemButton: true,
			duplicateItemsAllowed: false,
			delimiter: ' ',
			uniqueItemText: item.dataset.msgUniqueItem,
			customAddItemText: item.dataset.msgCustomAddItem,
			addItemText: value => item.dataset.msgAddItem.replace('%value%', value),
			addItemFilter: '^\\S+$',
		})
		
		fixSearchInput(item)
	})

	const allChoicesSelects = [...document.querySelectorAll('._choices-select, [data-choices="select"]')]
	const notSetUpChoicesSelects = allChoicesSelects.filter((choicesSelect) => !registeredChoicesElements.includes(choicesSelect))
	notSetUpChoicesSelects.map((item) => {
		registeredChoicesElements.push(item)
		
		item.choices = new Choices(item, {
			searchResultLimit: item.dataset.searchResultLimit,
			shouldSort: false,
			loadingText: item.dataset.msgLoading,
			noResultsText: item.dataset.msgNoResults,
			noChoicesText: item.dataset.msgNoChoices,
			itemSelectText: item.dataset.msgItemSelect,
			addItemText: value => item.dataset.msgAddItem.replace('%value%', value)
		})
		
		// Doplneni podpory pro autocomplete (pouzije nastaveni z atributu autocomplete puvodniho selectu)
		if (item.hasAttribute('autocomplete')) {
			const container = item.closest('.choices')
			
			const autocompleteElement = document.createElement('input')
			autocompleteElement.type = 'text'
			autocompleteElement.name = `${item.name}-autocomplete`
			autocompleteElement.classList.add('choices__autocomplete')
			autocompleteElement.setAttribute('aria-hidden', 'true')
			autocompleteElement.setAttribute('tabindex', '-1')
			autocompleteElement.setAttribute('autocomplete', item.getAttribute('autocomplete'))
			autocompleteElement.addEventListener('input', () => {
				item.choices.setChoiceByValue(autocompleteElement.value)
			})
			
			container.prepend(autocompleteElement)
		}
		
		fixSearchInput(item)
	})
}

redrawChoices();
document.addEventListener('DOMContentRefreshed', redrawChoices, false);
